import React, { useContext } from 'react';
import { Container } from '../../components/helpers/Grid';
import useHabitat from '../../hooks/useHabitat';
import PageHeader from '../../components/PageHeader';
import CompetitionCarousel from '../../components/CompetitionCarousel';
import FeaturedCompetitionsList from '../../components/FeaturedCompetitionsList';
import Sponsors from '../../components/Sponsors';
import Tabs, { Tab, TabPanel } from '../../components/common/Tabs';
import Calendar from '../../components/Calendar';
import LocalizationContext from '../../contexts/Localizations';
import DisciplineModuleProps from './type';
import { resetQueryString } from '../Calendar/methods';
import './styles.scss';

const disciplineIdMap = {
  track: 9,
  road: 10,
  trials: 12,
  indoor: 5,
  para: 8,
  'bmx-racing': 1,
  'cyclo-cross': 3,
  'mountain-bike': 7,
  'bmx-freestyle': 13,
  gravel: 15,
};

const DisciplineModule = ({
  header,
  carousel,
  featuredCompetitions,
  activeTab,
  content,
  discipline,
  sponsors,
  calendar,
  hasRankings,
  calendarDownloadOptions,
  bearerToken,
}: DisciplineModuleProps) => {
  const { translations } = useContext(LocalizationContext);
  // @ts-ignore
  const disciplineId = disciplineIdMap[discipline.replace(/\s+/g, '-').toLowerCase()];
  useHabitat();

  return (
    <div className={`discipline-module page-template discipline-module--${discipline}`}>
      {header && (
        <PageHeader {...header} />
      )}

      {(carousel?.latest || !!carousel?.upcoming?.length) && (
        <section
          className="discipline-module__carousel"
          aria-label="Upcoming competitions"
        >
          <div className="discipline-module__carousel-container">
            <CompetitionCarousel cards={carousel} themeColor={header?.heroImage ? 'transparentDark' : 'blue'} />
          </div>
        </section>
      )}

      {featuredCompetitions && featuredCompetitions.length && activeTab !== 'TechnicalRankings' && activeTab !== 'YellowCards' && (
        <FeaturedCompetitionsList
          links={featuredCompetitions}
          discipline={discipline}
          viewMoreLabel={translations.calendar.viewMoreLabel}
        />
      )}

      {!calendar && content && (
        // eslint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{
          __html: content,
        }}
        />
      )}

      {!content && calendar && calendar.isPast && (
        <Calendar
          filters={calendar.filters}
          disciplineCode={calendar.disciplineCode}
          bearerToken={bearerToken}
          isPast
          calendarDownloadOptions={calendarDownloadOptions}
        />
      )}

      {!content && calendar && !calendar.isPast && (
        <Tabs changeTabCallBack={resetQueryString} isCalendar>
          <Tab
            key="calendar-upcoming"
            id="calendar-upcoming"
            label={translations.calendar.upcomingLabel}
          />
          <Tab
            key="calendar-past"
            id="calendar-past"
            label={translations.calendar.pastLabel}
          />
          <TabPanel key="panel-calendar-upcoming" tabId="calendar-upcoming">
            <Calendar
              filters={calendar.filters}
              disciplineCode={calendar.disciplineCode}
              bearerToken={bearerToken}
              allowMultipleSelection
              calendarDownloadOptions={calendarDownloadOptions}
            />
          </TabPanel>

          <TabPanel key="panel-calendar-past" tabId="calendar-past">
            <Calendar
              filters={calendar.filters}
              disciplineCode={calendar.disciplineCode}
              bearerToken={bearerToken}
              isPast
              allowMultipleSelection
              calendarDownloadOptions={calendarDownloadOptions}
            />
          </TabPanel>
        </Tabs>
      )}

      {Boolean(hasRankings && disciplineId) && (
        <div className="discipline-module__data-ride">
          <Container>
            <iframe title="results" src={`https://dataride.uci.ch/iframe/rankings/${disciplineId}`} />
          </Container>
        </div>
      )}

      {sponsors && (
        <Sponsors sponsors={sponsors.sponsors} title={sponsors.title} />
      )}
    </div>
  );
};

export default DisciplineModule;
